import { UserRef } from 'models/user'
import { ActivityTrackingFilter } from '../../models/filter'

export const activityTrackingQuery = (
  f: ActivityTrackingFilter,
  startDate: moment.Moment,
  endDate: moment.Moment,
): { [key: string]: string } => {
  let queryParams: { [key: string]: string } = {
    start: `${startDate.format('DD-MM-YYYY')}`,
    end: `${endDate.format('DD-MM-YYYY')}`,
  }
  if (f.page) {
    queryParams['page'] = `${f.page}`
  }

  if (f.systemAreas && f.systemAreas.length > 0) {
    queryParams['system_areas'] = `${f.systemAreas.map((t) => t)}`
  }

  if (f.listings && f.listings.length > 0) {
    queryParams['listing_ids'] = `${f.listings.map((t) => t.id)}`
  }

  if (f.term && f.term.tenantTerms && f.term.tenantTerms.length > 0 && f.term.tenantTerms[0] !== undefined) {
    queryParams['tenant_terms'] = f.term?.tenantTerms.map((t) => t).join(',')
  }

  if (f.term && f.term.accessPlanTerms && f.term.accessPlanTerms.length > 0 && f.term.accessPlanTerms[0] !== undefined) {
    queryParams['access_plan_terms'] = f.term?.accessPlanTerms.map((t) => t).join(',')
  }

  if (f.term && f.term.waitlistTerms && f.term.waitlistTerms.length > 0 && f.term.waitlistTerms[0] !== undefined) {
    queryParams['waitlistTerms'] = f.term?.waitlistTerms.map((t) => t).join(',')
  }

  if (f.term && f.term.listingTerms && f.term.listingTerms.length > 0 && f.term.listingTerms[0] !== undefined) {
    queryParams['listing_terms'] = f.term?.listingTerms.map((t) => t).join(',')
  }

  if (f.term && f.term.discountPlanTerms && f.term.discountPlanTerms.length > 0 && f.term.discountPlanTerms[0] !== undefined) {
    queryParams['discountPlanTerms'] = f.term?.discountPlanTerms.map((t) => t).join(',')
  }

  if (f.term && f.term.discountPlanTerms && f.term.discountPlanTerms.length > 0 && f.term.discountPlanTerms[0] !== undefined) {
    queryParams['discountPlanTerms'] = f.term?.discountPlanTerms.map((t) => t).join(',')
  }

  if (
    f.term &&
    f.term.pricingSchemaTerms &&
    f.term.pricingSchemaTerms.length > 0 &&
    f.term.pricingSchemaTerms[0] !== undefined
  ) {
    queryParams['pricing_schema_terms'] = f.term?.pricingSchemaTerms.map((t) => t).join(',')
  }

  if (f.users && f.users.length > 0) {
    queryParams['modified_by'] = f.users.map((user: UserRef) => user.id).join(',')
  }

  return queryParams
}
